import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectStorageLocation from './../../components/site/select_storage_location'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectStorageLocation: state.searchFormCondition.selectStorageLocation,
})

const SelectStorageLocationContainer = connect(mapStateToProps, mapDispatchToProps)(SelectStorageLocation)

export default SelectStorageLocationContainer
